export default "/static/images/build_roof_3.png?917ec1133a1e23e09d6739a1f6f49e44";